"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productV2ToCode = exports.productV2FromCode = void 0;
const errors_1 = require("@wolf/errors");
const product_v2_1 = require("./models/product-v2");
const types_1 = require("./types");
const utils_1 = require("./utils");
const productV2AI = {
    '90': 'type',
    '20': 'sourceId',
    '251': 'workspaceId',
    '92': 'salesGroupId',
    '21': 'productId',
    '8008': 'date',
    '240': 'index',
};
const productV2FromCode = (code) => {
    try {
        const codes = (0, utils_1.stringToCodes)(code);
        if ('productId' in codes) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Incorrect format');
        }
        const product = codes.reduce((previousCodes, code) => {
            return {
                ...previousCodes,
                [productV2AI[code.code]]: Number(code.value),
            };
        }, {});
        const productParse = product_v2_1.ProductV2FromBarcode.safeParse(product);
        if (!productParse.success || productParse.data.type !== Number(types_1.type.productV2)) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Invalid product identifier');
        }
        return productParse.data;
    }
    catch (error) {
        throw new errors_1.ApplicationError(`${error}`);
    }
};
exports.productV2FromCode = productV2FromCode;
const productV2ToCode = (product) => {
    const swappedProduct = Object.entries(productV2AI).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});
    const code = Object.keys(product).reduce((previousCode, key) => {
        return (previousCode +
            '(' +
            swappedProduct[key] +
            ')' +
            (0, utils_1.formatToCode)(product[key]));
    }, '');
    return types_1.typeIA + types_1.type.productV2 + code;
};
exports.productV2ToCode = productV2ToCode;
//# sourceMappingURL=product-v2.js.map